var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-12 col-md-3 col-lg-2 saas-message-sidebar" },
    [
      _c(
        "nav",
        {
          staticClass: "admin-message-tabs",
          attrs: { "aria-label": _vm.trans("message.message") },
        },
        [
          _c("ul", { staticClass: "admin-message-tabs__list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active":
                        _vm.menu === "compose",
                    },
                    attrs: { to: "/message/compose" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "send", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trans("message.compose")))]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active": _vm.menu === "draft",
                    },
                    attrs: { to: "/message/draft" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "pencil", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trans("message.draft")))]),
                    _vm._v(" "),
                    _vm.statistics && _vm.statistics.draft
                      ? _c(
                          "span",
                          { staticClass: "admin-message-tabs__count" },
                          [_vm._v("(" + _vm._s(_vm.statistics.draft) + ")")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active": _vm.menu === "inbox",
                    },
                    attrs: { to: "/message/inbox" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "inbox", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trans("message.inbox")))]),
                    _vm._v(" "),
                    _vm.statistics && _vm.statistics.inbox
                      ? _c(
                          "span",
                          { staticClass: "admin-message-tabs__count" },
                          [_vm._v("(" + _vm._s(_vm.statistics.inbox) + ")")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active": _vm.menu === "sent",
                    },
                    attrs: { to: "/message/sent" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "share", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trans("message.sent_box")))]),
                    _vm._v(" "),
                    _vm.statistics && _vm.statistics.sent
                      ? _c(
                          "span",
                          { staticClass: "admin-message-tabs__count" },
                          [_vm._v("(" + _vm._s(_vm.statistics.sent) + ")")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active":
                        _vm.menu === "important",
                    },
                    attrs: { to: "/message/important" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "star", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.trans("message.important"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "admin-message-tabs__link",
                    class: {
                      "admin-message-tabs__link--active": _vm.menu === "trash",
                    },
                    attrs: { to: "/message/trash" },
                  },
                  [
                    _c("admin-icon", {
                      attrs: { name: "trash", "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.trans("message.trash")))]),
                    _vm._v(" "),
                    _vm.statistics && _vm.statistics.trash
                      ? _c(
                          "span",
                          { staticClass: "admin-message-tabs__count" },
                          [_vm._v("(" + _vm._s(_vm.statistics.trash) + ")")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }